var productListMetadata = function (title, description, keywords) {

    var baseTitle = title;
    var baseDescription = description;
    var baseKeywords = keywords;

    var ratingTitle = "";
    var colorTitle = "";
    var tagsTitle = "";
    var priceTitle = "";
    var productionTimeTitle = "";
    var imprintLocationCountTitle = "";
    var imprintColorCountTitle = "";
    var pageSizeTitle = "";
    var pageTitle = "";
    var orderTitle = "";

    var ratingDescription = "";
    var colorDescription = "";
    var tagsDescription = "";
    var priceDescription = "";
    var productionTimeDescription = "";
    var imprintLocationCountDescription = "";
    var imprintColorCountDescription = "";
    var pageSizeDescription = "";
    var pageDescription = "";
    var orderDescription = "";

    var ratingKeywords = "";
    var colorKeywords = "";
    var tagsKeywords = "";
    var priceKeywords = "";
    var productionTimeKeywords = "";
    var imprintLocationCountKeywords = "";
    var imprintColorCountKeywords = "";
    var pageSizeKeywords = "";
    var pageKeywords = "";
    var orderKeywords = "";

    function setProductionTime(productionTime) {
        if (productionTime != "") {
            var productionTimeFilter = localizedJS.ProductionTimeFilterTitle.replace('##PRODTIME##', productionTime);
            productionTimeTitle = ' | ' + productionTimeFilter;
            productionTimeDescription = ' ' + productionTimeFilter;
            productionTimeKeywords = ', ' + productionTimeFilter;
        } else {
            productionTimeTitle = "";
            productionTimeKeywords = "";
            productionTimeDescription = "";
        }
    }
    
    function setImprintLocationCount(imprintLocationCount) {
        if (imprintLocationCount != "") {
            var imprintLocationCountFilter = localizedJS.ImprintLocationCountFilterTitle.replace('##IMPLOC##', imprintLocationCount);
            imprintLocationCountTitle = ' | ' + imprintLocationCountFilter;
            imprintLocationCountDescription = ' ' + imprintLocationCountFilter;
            imprintLocationCountKeywords = ', ' + imprintLocationCountFilter;
        } else {
            imprintLocationCountTitle = "";
            imprintLocationCountKeywords = "";
            imprintLocationCountDescription = "";
        }
    }
    
    function setImprintColorCount(imprintColorCount) {
        if (imprintColorCount != "") {
            var imprintColorCountFilter = localizedJS.ImprintColorCountFilterTitle.replace('##IMPCOLOR##', imprintColorCount);
            imprintColorCountTitle = ' | ' + imprintColorCountFilter;
            imprintColorCountDescription = ' ' + imprintColorCountFilter;
            imprintColorCountKeywords = ', ' + imprintColorCountFilter;
        } else {
            imprintColorCountTitle = "";
            imprintColorCountKeywords = "";
            imprintColorCountDescription = "";
        }
    }

    function setRating(rating) {
        var vals = rating.split('_');
        var title = "";
        var description = "";
        var keywords = "";
        for (var i = 0; i < vals.length; i++) {
            if (vals[i] != "") {
                var ratingFilter = localizedJS.RatingFilterTitle.replace('##RATING##', vals[i]);
                title += ' | ' + ratingFilter;
                description += ' ' + ratingFilter;
                keywords += ', ' + ratingFilter;
            }
        }
        ratingTitle = title;
        ratingDescription = description;
        ratingKeywords = keywords;
    }

    function setColor(color) {
        var vals = color.split('_');
        var title = "";
        var description = "";
        var keywords = "";
        for(var i = 0; i < vals.length; i++){
            if (vals[i] != "") {
                var colorFilter = localizedJS.ColorFilterTitle.replace('##COLORNAME##', vals[i]);
                title += ' | ' + colorFilter;
                description += ' ' + colorFilter;
                keywords += ', ' + colorFilter;
            }
        }
        colorTitle = title;
        colorDescription = description;
        colorKeywords = keywords;   
    }

    function setPrice(low, high) {
        if (low != "" && high != "") {
            var priceFilter = localizedJS.PriceFilterTitle.replace('##PRICELOW##', low).replace('##PRICEHIGH##', high);
            priceTitle = ' | ' + priceFilter;
            priceDescription = ' ' + priceFilter;
            priceKeywords = ', ' + priceFilter;
        } else {
            priceTitle = "";
            priceDescription = "";
            priceKeywords = "";
        }
    }

    function setTags(tags) {
        var vals = tags.split('_');
        var title = "";
        var description = "";
        var keywords = "";
        for (var i = 0; i < vals.length; i++) {
            if (vals[i] != "") {
                var tagFilter = localizedJS.TagFilterTitle.replace('##TAGNAME##', vals[i]);
                title += ' | ' + tagFilter;
                description += ' ' + tagFilter;
                keywords += ', ' + tagFilter;
            }
        }
        tagsTitle = title;
        tagsDescription = description;
        tagsKeywords = keywords;
    }

    function setPageSize(pageSize) {
        if (pageSize != 50) {
            var pageSizeFilter = localizedJS.PageSizeTitle.replace('##PAGESIZE##', pageSize);
            pageSizeTitle = ' | ' + pageSizeFilter;
            pageSizeDescription = ' ' + pageSizeFilter;
            pageSizeKeywords = ', ' + pageSizeFilter;
            
        } else {
            pageSizeTitle = '';
            pageSizeDescription = '';
            pageSizeKeywords = '';
        }
    }

    function setPage(page) {
        if (page != 1) {
            var pageFilter = localizedJS.PageNumberTitle.replace('##PAGENUM##', page);
            pageTitle = ' | ' + pageFilter;
            pageDescription = ' ' + pageFilter;
            pageKeywords = ', ' + pageFilter;
        }else{
            pageTitle = '';
            pageDescription = '';
            pageKeywords = '';
        }
    }

    function setOrder(order) {
        if (order != '') {
            var orderFilter = localizedJS.PageSortTitle.replace('##SORTDESC##', order);
            orderTitle = ' | ' + orderFilter;
            orderDescription = ' ' + orderFilter;
            orderKeywords = ', ' + orderFilter;
            
        } else {
            orderTitle = '';
            orderDescription = '';
            orderKeywords = '';
        }
    }

    function getTitle() {
        return baseTitle +
                productionTimeTitle +
                imprintLocationCountTitle +
                imprintColorCountTitle +
                ratingTitle +
                priceTitle +
                colorTitle +
                tagsTitle +
                pageSizeTitle +
                pageTitle +
                orderTitle;
    }

    function getDescription() {
        return baseDescription +
                productionTimeDescription +
                imprintLocationCountDescription + 
                imprintColorCountDescription +
                ratingDescription +
                priceDescription +
                colorDescription +
                tagsDescription +
                pageSizeDescription +
                pageDescription +
                orderDescription;
    }

    function getKeywords() {
        return baseKeywords +
                productionTimeKeywords +
                imprintLocationCountDescription +
                imprintColorCountDescription +
                ratingKeywords +
                priceKeywords +
                colorKeywords +
                tagsKeywords;// +
                //pageSizeKeywords +
                //pageKeywords +
                //orderKeywords;
    }

    return {
        SetProductionTime: setProductionTime,
        SetImprintLocationCount: setImprintLocationCount,
        SetImprintColorCount: setImprintColorCount,
        SetRating: setRating,
        SetColor: setColor,
        SetPrice: setPrice,
        SetTags: setTags,
        SetPageSize: setPageSize,
        SetPage: setPage,
        SetOrder: setOrder,
        GetTitle: getTitle,
        GetDescription: getDescription,
        GetKeywords: getKeywords
    }
};